import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { GuideStep } from './types';

export type UpdateGuideStepOptions = {
   title: string;
   time_estimate?: number;
   lines: {
      text: string;
      bullet_styleid: number;
      level: number;
   }[];
   media:
      | null
      | {
           type: 'IMAGE';
           data: number[];
        }
      | {
           type: 'OBJECT';
           data: number;
        };
};

export async function updateGuideStep(
   guideId: number,
   stepId: number,
   revisionId: number,
   step: UpdateGuideStepOptions,
   common: CommonRequestOptions = {}
): Promise<GuideStep> {
   return makeRequest('patch', `/guides/${guideId}/steps/${stepId}`, {
      ...common,
      query: {
         revisionid: revisionId,
      },
      body: step,
   });
}
